import ServerSelector_vue_vue_type_script_setup_true_lang_default from "./ServerSelector.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ServerSelector.vue
var ServerSelector_default = ServerSelector_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ServerSelector_default as default };

//# sourceMappingURL=ServerSelector.vue.js.map